import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  color: var(--primary-color);
  font-weight: 500;
  margin-bottom: 0.5rem;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
  
  svg {
    margin-right: 0.25rem;
  }
`;

const Title = styled.h1`
  font-size: 1.875rem;
  color: var(--gray-900);
  margin-bottom: 0.25rem;
`;

const Subtitle = styled.p`
  color: var(--gray-500);
  font-size: 1rem;
  margin-bottom: 0.5rem;
`;

const Description = styled.p`
  color: var(--gray-600);
  max-width: 700px;
`;

function PageHeader({ title, description, subtitle, backLink, backText }) {
  return (
    <HeaderContainer>
      {backLink && (
        <BackLink to={backLink}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          {backText || 'Back'}
        </BackLink>
      )}
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {description && <Description>{description}</Description>}
    </HeaderContainer>
  );
}

export default PageHeader;